import {FormCheck, Modal, Button} from "react-bootstrap";
import {I18n} from "@aws-amplify/core";
import React from "react";
import * as PropTypes from "prop-types";

const AffiliateAgreementsComponent = (props) => {
    let agree_btn = null;
    if (props.disabled) {
        agree_btn =
            <Button variant="secondary" disabled={props.disabled} onClick={props.onClick1}>
                同意する
            </Button>

    } else {
        agree_btn =
            <Button variant="primary" disabled={props.disabled} onClick={props.onClick1}>
                同意する
            </Button>
    }
    return <Modal show={props.show} onHide={props.onHide}>
        <Modal.Header>
            <Modal.Title>{I18n.get("遺伝子検査結果に基づいたおすすめアイテムの購入を希望する場合以下に同意のうえご購入ください。")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <FormCheck id="agreement1" className="img-check" type="checkbox" name='agreement1' onClick={props.onClick} value={props.agreement1}
                       label="おすすめアイテムをご購入いただくにあたり、結果に基づくアイテム推奨のためにお客様の検査結果から導かれるアイテムに関する情報が暗号化された形でアイテム販売元に通知されます。"/>
                     <FormCheck id="agreement2" className="img-check" type="checkbox" name='agreement2' onClick={props.onClick} value={props.agreement2}
                       label="おすすめアイテムの購入はアイテム販売元が運営するECサイト上でのご購入となります。"/>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="light" onClick={props.onHide} className="btn-transparent">
                後で
            </Button>
            {agree_btn}
        </Modal.Footer>
    </Modal>;
};

AffiliateAgreementsComponent.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    onClick: PropTypes.func,
    agreement1: PropTypes.bool,
    agreement2: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick1: PropTypes.func
};

export default AffiliateAgreementsComponent;
